export default __webpack_public_path__ + "/dist/images/5977195.213b5a705627c26142a686344d7b4dc0.png";